exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram1-5c-1 .situation-title{text-align:left}#diagram1-5c-1 .simplest__structure-framework__diagram-box-bottom{margin-top:90px}#diagram1-5c-1 .structure-box-list{height:100px!important}#diagram1-5c-1 .diagram-header{margin-right:147px;width:150px;min-height:62px}.diagram1-5c-1.unit-diagram{min-height:773px}.diagram1-5c-1 .simplest__submit{bottom:350px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5c/diagram1/diagram1.scss
// module id = 1418
// module chunks = 0